import { DEFAULT_SPACEY_INSTRUCTION_MESSAGE_COLOR } from '../constants/spaceyDefaults';

const DEFAULT_GRADIENT_END = '#2e9cfd';

const clamp = (n) => Math.min(255, Math.max(0, Math.round(n)));

const parseHex = (hex) => {
  const normalized = String(hex || '').trim().replace(/^#/, '');
  if (normalized.length === 3) {
    const [r, g, b] = normalized.split('');
    return {
      r: parseInt(r + r, 16),
      g: parseInt(g + g, 16),
      b: parseInt(b + b, 16),
    };
  }
  if (normalized.length !== 6 || !/^[0-9a-f]+$/i.test(normalized)) {
    return null;
  }
  return {
    r: parseInt(normalized.slice(0, 2), 16),
    g: parseInt(normalized.slice(2, 4), 16),
    b: parseInt(normalized.slice(4, 6), 16),
  };
};

const toHex = ({ r, g, b }) =>
  `#${[r, g, b].map((c) => clamp(c).toString(16).padStart(2, '0')).join('')}`;

const lighten = (hex, amount = 0.22) => {
  const rgb = parseHex(hex);
  if (!rgb) return DEFAULT_GRADIENT_END;
  return toHex({
    r: rgb.r + (255 - rgb.r) * amount,
    g: rgb.g + (255 - rgb.g) * amount,
    b: rgb.b + (255 - rgb.b) * amount,
  });
};

export const normalizeHexColor = (value, fallback = DEFAULT_SPACEY_INSTRUCTION_MESSAGE_COLOR) => {
  const trimmed = String(value || '').trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(trimmed)) {
    return trimmed.toLowerCase();
  }
  if (/^#[0-9A-Fa-f]{3}$/.test(trimmed)) {
    const h = trimmed.slice(1);
    return `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`.toLowerCase();
  }
  return fallback;
};

/** Matches site default gradient when unset; lighter second stop for custom colours. */
export const hexToRgba = (hex, alpha = 1) => {
  const rgb = parseHex(hex);
  if (!rgb) return `rgba(47, 128, 237, ${alpha})`;
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
};

export const buildInstructionMessageBackground = (color) => {
  const base = normalizeHexColor(color);
  if (base === DEFAULT_SPACEY_INSTRUCTION_MESSAGE_COLOR.toLowerCase()) {
    return `linear-gradient(to right, ${DEFAULT_SPACEY_INSTRUCTION_MESSAGE_COLOR}, ${DEFAULT_GRADIENT_END})`;
  }
  return `linear-gradient(to right, ${base}, ${lighten(base)})`;
};

export default buildInstructionMessageBackground;
